import React, { useState, useEffect } from 'react';
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Autocomplete, FormControlLabel, CircularProgress, Box, FormGroup, Typography, Tooltip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { addEolApi, updateEolApi, leaseOptionTypeApi} from '../apiService';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { PageLoader } from '../../../../shared_elements';
import moment from 'moment';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { trackActivity } from '../../../../utils/mixpanel';
import { formatBytes } from '../../../../utils/fileUpload';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const EolCRU = ({ eolCRU, modeType, getResponseBack, fileUpload, onOpenAttachments, onToggleModal }) => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const { storageDetails } = useSelector((state) => state.leases);
    const params = { leaseSlug: leaseSlug };
    const [error, setError] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(eolCRU?.data);
    const { enqueueSnackbar } = useSnackbar()
    const [attachments, setAttachments] = useState([]);
    const [leaseOption, setLeaseOption] = useState([]);
    const [dropDownLoader, setDropDownLoader] = useState(false);
    const [cleared, setCleared] = useState(false);

    useEffect(() => {
        getLeaseOptionApi()
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [])

    const handleFileChange = (files) => {
        setAttachments(files);
         dispatch(setFileUploadDetails({attachments:files}))
    };

    const onFieldChange = (key, value) => {
        if (key === "lease_option") {
            setData({ ...data, [key]: value, extension_start_date: null, extension_end_date: null, extension_rent_type: null });
            setError((prev) => ({ ...prev, [key]: '', extension_start_date: "", extension_end_date: "" }));
        }
        else {
            setData({ ...data, [key]: value });
            setError((prev) => ({ ...prev, [key]: '' }));
        }
    };
    const getLeaseOptionApi = () => {
        setDropDownLoader(true);
        globalPostService(leaseOptionTypeApi(), { "constant_types": ["lease_option_type"] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setLeaseOption(response?.data?.data);
                }
                setDropDownLoader(false);
            })
    }

    const onAddEditEol = () => {
        let validationInputs = {};
        validationInputs = {
            lease_option: data?.lease_option ? "" : "Please select Lease Option",
            details: data?.details?.trim() ? "" : "Please enter Details",
            extension_start_date: data?.lease_option?.value===3 ? data?.extension_start_date ? '' : "Please select Extension Start Date" : '',
            extension_end_date: data?.lease_option?.value===3 ? data?.extension_end_date ? '' : "Please select Extension End Date" : '',
        };
        const extEndDate=moment(data?.extension_end_date);
        const validityStartDate = moment(data?.validity_start_date); 
        const validityEndDate = moment(data?.validity_end_date);
        const noticePeriodStartDate = moment(data?.notice_period_start_date);
        const noticePeriodEndDate = moment(data?.notice_period_end_date);
        const extensionStartDate = moment(data?.extension_start_date);
        const extensionEndDate = moment(data?.extension_end_date);

        if(data?.lease_option?.value===3 && data?.notice_period_start_date && extEndDate.isBefore(moment(data?.notice_period_start_date))){
            validationInputs.extension_end_date = "Extension End Date should not be Before than Notice Period Start Date";
        }
        if(data?.notice_period_start_date && data?.notice_period_end_date &&  noticePeriodEndDate.isBefore(noticePeriodStartDate)){
            validationInputs.notice_period_end_date = "Notice Period End Date cannot be before Notice Period Start Date";
        }
        if( data?.extension_end_date && data?.extension_start_date && extensionEndDate.isBefore(extensionStartDate)){
            validationInputs.extension_end_date = "Extension End Date cannot be before Extension Start Date";
        }
        if(data.validity_start_date && !validityStartDate.isValid()) {
            validationInputs.validity_start_date = "Please enter valid Start Date";
        }
        if(data.validity_end_date && !validityEndDate.isValid()) {
            validationInputs.validity_end_date = "Please enter valid End Date";
        }
        if(data.notice_period_start_date && !noticePeriodStartDate.isValid()) {
            validationInputs.notice_period_start_date = "Please enter valid Notice Period Start Date";
        }
        if(data.notice_period_end_date && !noticePeriodEndDate.isValid()) {
            validationInputs.notice_period_end_date = "Please enter valid Notice Period End Date";
        }
        if(data.extension_end_date && !extensionEndDate.isValid()) {
            validationInputs.extension_end_date = "Please enter valid Extension End Date";
        }

        let payload = Object.assign({}, data)
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data?.id) {
                globalPutService(updateEolApi({ ...params, slug: data?.slug }), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit EOL Option`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit EOL Option`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                    setLoading(false);
                });
            } else {
                globalPostService(addEolApi(params), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add EOL Option`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add EOL Option`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} EOL Option`, error_msg: validationInputs, })
        }
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} EOL Option`, page_type: page_type, })
    }
  
    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    return (
        <>
            <Dialog
                // onClose={onToggleModal}
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === 'add' ? 'Add EOL Option' : modeType === 'edit' ? 'Edit EOL Option' : 'View EOL Option'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={leaseOption || []}
                                getOptionLabel={(option) => option?.label || ""}
                                noOptionsText={ dropDownLoader && modeType !== "view" ? "Loading..." : "No Option Available" }
                                disabled={modeType === 'view'}
                                value={data?.lease_option || null}
                                onChange={(e, value) => { onFieldChange("lease_option", value) }}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                {...params}
                                                label="Lease Option"
                                                margin='normal'
                                                size='small'
                                                required
                                                error={!!error.lease_option}
                                                helperText={error.lease_option}
                                                disabled={modeType === 'view'}
                                                slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: modeType !== "view" && dropDownLoader ? ( <CircularProgress color="inherit" size={20} /> ) : ( params.InputProps.endAdornment ), }, }}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity Start Date"
                                    value={data?.validity_start_date ? moment(data.validity_start_date) : null}
                                    onChange={(data) => onFieldChange("validity_start_date", data ? moment(data).format(backendDateFormat) : null)}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.validity_start_date || false,
                                            helperText: error.validity_start_date || '',
                                            onFocus: () => { error.validity_start_date && onRestErrorKey("validity_start_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("validity_start_date", null);
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity End Date"
                                    value={data?.validity_end_date ? moment(data.validity_end_date) : null}
                                    onChange={(data) => onFieldChange("validity_end_date", data ? moment(data).format(backendDateFormat) : null)}
                                    minDate={data?.validity_start_date ? moment(data.validity_start_date) : null}
                                    slotProps={{
                                        popper: { placement: 'bottom-end' },
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.validity_end_date || false,
                                            helperText: error.validity_end_date || '',
                                            onFocus: () => { error.validity_end_date && onRestErrorKey("validity_end_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("validity_end_date", null);
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Notice Period Start Date"
                                    value={data?.notice_period_start_date ? moment(data.notice_period_start_date) : null}
                                    onChange={(data) => onFieldChange("notice_period_start_date", data ? moment(data).format(backendDateFormat) : null)}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.notice_period_start_date || false,
                                            helperText: error.notice_period_start_date || '',
                                            onFocus: () => { error.notice_period_start_date && onRestErrorKey("notice_period_start_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("notice_period_start_date", null);
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Notice Period End Date"
                                    value={data?.notice_period_end_date ? moment(data.notice_period_end_date) : null}
                                    onChange={(data) => onFieldChange("notice_period_end_date", data ? moment(data).format(backendDateFormat) : null)}
                                    minDate={data?.notice_period_start_date ? moment(data.notice_period_start_date) : null}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.notice_period_end_date || false,
                                            helperText: error.notice_period_end_date || '',
                                            onFocus: () => { error.notice_period_end_date && onRestErrorKey("notice_period_end_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("notice_period_end_date", null);
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        {data?.lease_option?.value===3 && (<>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Extension  Start Date"
                                    value={data?.extension_start_date ? moment(data.extension_start_date) : null}
                                    onChange={(data) => onFieldChange("extension_start_date", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null)}
                                    slotProps={{
                                        popper: { placement: 'bottom-end' },
                                        textField: {
                                            required:"true",
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.extension_start_date || false,
                                            helperText: error.extension_start_date || '',
                                            onFocus: () => { error.extension_start_date && onRestErrorKey("extension_start_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("extension_start_date", null);
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Extension  End Date"
                                    value={data?.extension_end_date ? moment(data.extension_end_date) : null}
                                    // onChange={(data) => onFieldChange("extension_end_date", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null)}
                                    onChange={(data) => onFieldChange("extension_end_date", data ? moment(data).format(backendDateFormat) : null)}
                                    minDate={data?.extension_start_date ? moment(data.extension_start_date) : null}
                                    slotProps={{
                                        textField: {
                                            required:"true",
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.extension_end_date || false,
                                            helperText: error.extension_end_date || '',
                                            onFocus: () => { error.extension_end_date && onRestErrorKey("extension_end_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("extension_end_date", null);
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="extension_rent_type"
                                label="Extension Rent Type"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth
                                value={data?.extension_rent_type || ''}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value?.length <= 255 ? onFieldChange("extension_rent_type", e.target.value) : e.preventDefault() : null }
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        </>)}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="continuous"
                                label="Continuous"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100}}}
                                fullWidth
                                value={data?.continuous || ""}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("continuous", e.target.value.trimStart()) : e.preventDefault()
                                }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="recurring"
                                label="Recurring"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100}}}
                                fullWidth
                                value={data?.recurring || ""}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("recurring", e.target.value.trimStart()) : e.preventDefault()
                                }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Details' required={true} value={data?.details || ""} />
                        </Grid> :
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                required
                                id="details"
                                label="Details"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                slotProps={{ inputLabel: { shrink: true }}}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                fullWidth
                                multiline
                                rows={3}
                                error={!!error.details}
                                helperText={error.details}
                                value={data?.details || ''}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("details", e.target.value.trimStart()) : e.preventDefault()
                                }}
                            />
                        </Grid>}
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={data?.remarks || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                    }}
                                    disabled={modeType === 'view'}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{mt: 3}}>
                            <Box className="responsive-buttons">
                            {data?.id && data?.attachments?.length ?
                                <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({data?.attachments?.length})Attachment(s)</Button> : null
                            }
                            <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditEol() }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>

    )
}
export default EolCRU;